import axios from "../_defaults/user";
import moment from 'moment';

const baseUrl = "/admin-data-counters"

export async function getUsers({fromDate: userFromDate, toDate: userToDate, role}) {

    const fromDate = userFromDate || moment().subtract(7, 'day');
    const toDate = userToDate || moment();

    try {
        const response = await axios.get(
            `${baseUrl}/users`,
            {
                params: {
                    fromDate: fromDate.toString(),
                    toDate: toDate.toString(),
                    role
                }
            }
        );

        if(response?.data) {
            return response?.data;
        }

    } catch (error) {
        return error;
    }
}
